import type React from 'react';

import { Button, Link, Text } from '@change/ds-core-ui';

import { Translate, TranslateHtml } from '@change-corgi/core-react/i18n';

import { usePageBody } from './hooks/usePageBody';

export const PageBody: React.FC = () => {
	const {
		data: { url },
		actions: { trackClick },
	} = usePageBody();

	return (
		<>
			<Text as="div" className="mb-10">
				<TranslateHtml
					value="fe.pages.redirect.description"
					replacements={{
						url: (
							<Link
								href={url}
								onClick={() => trackClick('continue')}
								data-testid="continue-link"
								data-qa="continue-link"
							>
								{url}
							</Link>
						),
					}}
				/>
			</Text>
			<div>
				<Button
					as="a"
					className="mr-4 mb-2 w-full md:mb-0 md:w-auto"
					href={url}
					variant="primary"
					onClick={() => trackClick('continue')}
					data-testid="continue-button"
					data-qa="continue-button"
				>
					<Translate value="fe.pages.redirect.buttons.continue" />
				</Button>
				<Button
					as="a"
					className="w-full md:w-auto"
					href="/"
					variant="secondary"
					onClick={() => trackClick('back')}
					data-testid="back-button"
					data-qa="back-button"
				>
					<Translate value="fe.pages.redirect.buttons.go_to_change" />
				</Button>
			</div>
		</>
	);
};
